import "./projectOperation.css"
import { useCallback, useEffect, useState } from "react"
import { useParams } from "wouter"
import { getProjectOperations } from "../../../fetch/projects"
import { ProjectHeading } from "./ProjectHeading"
import { Group, Operation, Project, Task } from "../../../../types"
import classNames from "classnames"
import { BreadCrumbs } from "../../../components/breadcrumbs/BreadCrumbs"
import { OpenOperation } from "./OpenOperation"
import { isBitus } from "../../../../config/urls"
import { useWatcher } from "../../../lib/state/useWatcher"
import { tenantState } from "../../../store/tenant"
import { EditTask } from "./EditTask"
import { Portal } from "@/components/portal/Portal"
import { AddNewOperation } from "./AddOperation"
import { formatDate } from "@/lib/formatDate"

const formatTime = (ms: number) => {
  return `${Math.floor(ms / 60)}h ${ms % 60}min`
}

export const ProjectOperation = ({ projects }: { projects?: Project[] }) => {
  const {
    settings: { features },
  } = useWatcher(tenantState)
  const { projectId, id } = useParams()
  const [selectedOperation, setSelectedOperation] = useState<Operation>()

  const [project, setProject] = useState<Project | undefined>()
  const [groups, setGroups] = useState<Group[] | undefined>()

  const getUnits = (val: number, units?: boolean) => {
    if (units) {
      return val
    }
    return val ? val / 100 + " eur" : 0
  }

  const init = useCallback(() => {
    if (!id || !projectId) {
      return
    }
    getProjectOperations(id, projectId).then(async (res) => {
      setProject(res.project)
      setGroups(res.groups)
    })
  }, [id, projectId])

  useEffect(() => {
    init()
  }, [init])

  const active = projects?.find((proj) => id && proj.id === +id)
  console.log(groups)
  return (
    <>
      <Portal id="tabs-right">
        {projectId && <AddNewOperation onClose={init} projectId={+projectId} />}
      </Portal>
      <BreadCrumbs
        items={[
          { path: "/", title: "Projekti" },
          { path: `/${id}`, title: active?.name ?? "" },

          { path: `/${id}/${projectId}`, title: project?.name ?? "" },
        ]}
      />
      <OpenOperation
        operation={selectedOperation}
        onClose={() => setSelectedOperation(undefined)}
        subProjectId={projectId}
        projectId={id}
      />
      {project && (
        <ProjectHeading
          project={project}
          features={features}
          showOpEdit
          onSave={init}
        />
      )}
      {groups?.map((group, i) => (
        <div className="group" key={i}>
          <div className="title">{group.name}</div>
          {group.operations.map((operation, j) => (
            <div
              className="operation flex gap-8"
              key={j}
              onClick={() => setSelectedOperation(operation)}
            >
              <div className="operation-title w-full flex items-center">
                <div
                  className={classNames("status", `status-${operation.status}`)}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"
                      fill="currentColor"
                    />
                  </svg>
                </div>
                <div className="flex items-center w-full justify-between">
                  {operation.name}
                  {(operation?.plannedAt != null ||
                    operation?.plannedTo != null) && (
                    <span className="mx-4 block text-gray-500 text-[14px]">
                      Plānots:{" "}
                      {operation?.plannedAt
                        ? formatDate(operation.plannedAt, "dd.MMM yyyy") + " "
                        : ""}
                      {operation?.plannedTo
                        ? "līdz " +
                          formatDate(operation.plannedTo, "dd.MMM yyyy")
                        : ""}
                    </span>
                  )}
                </div>
              </div>
              <div className="flex gap-2 items-center shrink-0">
                {!isBitus && (
                  <>
                    {formatTime(operation.timeUsed)} (
                    {formatTime(operation.timePredicted)}){" | "}
                  </>
                )}

                {features["units"] && (
                  <>
                    {getUnits(operation.unitsUsed, true)}
                    <> / </>
                    {getUnits(operation.unitsPredicted, true)}
                  </>
                )}
                {features["salary"] && (
                  <>
                    {features["units"] && " | "}
                    {operation.salaryUsed
                      ? getUnits(operation.salaryUsed)
                      : null}
                    {operation.salaryUsed ? <>€ / </> : null}
                    {getUnits(operation.salaryPredicted)}
                    <>€</>
                  </>
                )}
                <EditTask
                  onSave={init}
                  task={operation as unknown as Task}
                  features={features}
                />
              </div>
            </div>
          ))}
        </div>
      ))}
    </>
  )
}
